import React from "react";
import CustomDataTable from "../../shared/CustomDataTable";
import { formatDate } from "../../../../utils/utils";
import DefaultAvatar from "../../../../assets/img/user-placeholder.svg";
const buildColumns = (group) => [
  {
    key: "employee_identifier",
    label: "Jogador",
    sortKey: "employee_identifier",
    render: (_v, item) => {
      const employee = group.employees.find(
        (e) => e.employee_identifier === item.employee_identifier,
      );
      const avatarUrl = employee && employee.avatar && employee.avatar.url
        ? employee.avatar.url
        : DefaultAvatar;
      return (
        <span className="analytics-player-row">
          <img alt="" src={avatarUrl} className="analytics-player-row__avatar" />
          <span className="analytics-player-row__name">{item.employee_identifier}</span>
        </span>
      );
    },
  },
  {
    key: "product",
    label: "Produto",
    sortKey: "product",
    render: (_v, item) => item.product && item.product.external_identifier,
  },
  { key: "description", label: "Descrição", sortKey: "description" },
  { key: "points", label: "Pontos fortes", sortKey: "points" },
  {
    key: "date",
    label: "Data",
    sortKey: "date",
    render: (_v, item) => formatDate(item.date),
  },
];

const sortFn = (data, sort) => {
  const sorted = [...data];
  sorted.sort((a, b) => {
    let valA, valB;
    if (sort.key === "product") {
      valA = (a.product && a.product.external_identifier) || "";
      valB = (b.product && b.product.external_identifier) || "";
    } else if (sort.key === "date") {
      valA = a.date ? new Date(a.date).getTime() : 0;
      valB = b.date ? new Date(b.date).getTime() : 0;
    } else if (sort.key === "points") {
      valA = Number(a.points) || 0;
      valB = Number(b.points) || 0;
    } else {
      valA = a[sort.key] || "";
      valB = b[sort.key] || "";
    }

    if (typeof valA === "string") {
      valA = valA.toLowerCase();
      valB = (valB || "").toLowerCase();
    }

    if (valA < valB) return sort.direction === "asc" ? -1 : 1;
    if (valA > valB) return sort.direction === "asc" ? 1 : -1;
    return 0;
  });
  return sorted;
};

const renderRow = (group, sale, index, className) => {
  const employee = group.employees.find(
    (e) => e.employee_identifier === sale.employee_identifier,
  );
  const name = sale.employee_identifier;
  const avatarUrl =
    employee.avatar && employee.avatar.url
      ? employee.avatar.url
      : DefaultAvatar;

  return (
    <tr key={sale.id || index} className={`data-table__row ${className}__row`}>
      <td
        className={`data-table__cell data-table__cell--employee_identifier ${className}__cell ${className}__cell--employee_identifier analytics-player-row`}
      >
        <img alt="" src={avatarUrl} className="analytics-player-row__avatar" />
        <span className="analytics-player-row__name">{name}</span>
      </td>
      <td
        className={`data-table__cell data-table__cell--product ${className}__cell ${className}__cell--product`}
      >
        {sale.product && sale.product.external_identifier}
      </td>
      <td
        className={`data-table__cell data-table__cell--description ${className}__cell ${className}__cell--description`}
      >
        {sale.description}
      </td>
      <td
        className={`data-table__cell data-table__cell--points ${className}__cell ${className}__cell--points`}
      >
        {sale.points}
      </td>
      <td
        className={`data-table__cell data-table__cell--date ${className}__cell ${className}__cell--date`}
      >
        {formatDate(sale.date)}
      </td>
    </tr>
  );
};

const SalesTable = ({ sales, pagination, group }) => (
  <CustomDataTable
    className="sales-table"
    columns={buildColumns(group)}
    data={sales}
    renderRow={(sale, index, className) =>
      renderRow(group, sale, index, className)
    }
    rowKey={(sale, index) => sale.id || index}
    sortFn={sortFn}
    pagination={pagination}
    emptyMessage="Sem vendas para apresentar."
  />
);

export default SalesTable;
